import { __awaiter } from '../../../external_node_modules/tslib/tslib.es6.js';
import { fetchUserInfo, getUserInfo } from '../../../api/user.js';
import { PLATFORMS } from '../../../constants/platforms.js';
import { UserEntity } from '../../entity/user.entity.js';
import settings from '../../../settings.js';
import { log } from '../../../utils/logger.js';

function getUser(force = false) {
    return __awaiter(this, void 0, void 0, function* () {
        const userInfo = force ? yield fetchUserInfo() : yield getUserInfo();
        const userEntity = new UserEntity(userInfo.spaCountry, userInfo.country, userInfo.accountId, PLATFORMS.WEB, userInfo.isAccountUncompleted, userInfo.billingAddress, userInfo.regional);
        if (settings.purchaseDisabled) {
            userEntity.disableUserPurchase();
        }
        log('[Web]', 'User data has been successfully fetched', userEntity, userInfo);
        return userEntity;
    });
}

export { getUser };
//# sourceMappingURL=user.js.map
